import { useEffect } from "react";
import globalStyles from "../v2/globalStyles";

type setThemParams = { darkMode?: boolean; element?: HTMLElement };

export const setTheme = ({ darkMode, element = document.body }: setThemParams) => {
  // we usually prefer body so theme takes affect on all elements,
  // including modals, and elements injected into the whatsapp DOM
  element.classList.remove(darkMode ? "theme-light" : "theme-dark");
  element.classList.add(darkMode ? "theme-dark" : "theme-light");
  if (darkMode) {
    element.classList.add(globalStyles["darkMode"]);
    return;
  }
  element.classList.remove(globalStyles["darkMode"]);
};

export const useTheme = ({ darkMode, element }: setThemParams) => {
  useEffect(() => {
    if (darkMode !== undefined) {
      setTheme({ darkMode, element });
    }
  }, [darkMode, element]);
};

/**
 * @deprecated this should be removed once we themify all used components
 */
export const useDeprecatedGlobalStyles = ({ element = document.body }: { element?: HTMLElement }) => {
  if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
    element.classList.add(globalStyles["darkMode"]);
  }
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", function (e) {
    if (e.matches) {
      element.classList.add(globalStyles["darkMode"]);
    } else {
      element.classList.remove(globalStyles["darkMode"]);
    }
  });
};
